module.exports = __webpack_public_path__ + "static/media/task8Planet2.dc6ed4f7.png";